import React from 'react';
import './DeviceInfo.css';
import { formatDate } from './Utils';

const deviceNames = {
  "oudie1": "Oudie",
  "oudie2": "Oudie 2",
  "oudie3": "Oudie 3",
  "oudieIGC": "Oudie IGC",
  "blade": "Blade",
  "oudie4Basic": "Oudie 4 Basic",
  "oudie4": "Oudie 4 Full",
  "hyper": "Hyper",
  "oudie5Basic": "Oudie 5 XC",
  "oudie5": "Oudie 5 Pro",
  "oudieNG": "Oudie N Gliding",
  "oudieNF": "Oudie N Free Flight",
  "oudieNF+": "Oudie N Fanet+",
  "oudieNIGC": "Oudie N IGC",
  "omniF+": "Omni",
  "LX8030": "LX8030",
  "LX8040": "LX8040",
  "LX9000": "LX9000",
  "LX9050": "LX9050",
  "LX9070": "LX9070"
};

const deviceName = (device) => {
  return deviceNames[device.device] || device.device;
};

const deviceSerial = (device) => {
  return device.serial !== 0 ? device.serial : device.device === "oudieNIGC" ? "NAV-" + device.key.replaceAll("-", "") : device.key;
}

const DeviceInfo = ({ devices }) => {
  return (
    <div className="device-info">
      <ul className="device-list">
        {devices.map((device, index) => (
          <li key={index} className="device-item">
            <p className="device-detail meta">
              <strong>{deviceName(device)}</strong>{' '}
              <span className="device-serial">{deviceSerial(device)}</span>
            </p>
            <div className="device-links">
              <a
                href={device.serial !== 0
                  ? `https://devices.seeyou.cloud/devices?search=${deviceSerial(device)}`
                  : `https://devices.seeyou.cloud/devices/${deviceSerial(device)}/view`}
                target="_blank"
                rel="noreferrer"
                className="device-link workshop-link"
              >
                Devices
              </a>
            </div>
            {device.settings?.navigator_version && (
              <p className="device-detail meta">
                <strong>Version:</strong> {device.settings.navigator_version}
              </p>
            )}
            {device.registered_at && (
              <p className="device-detail meta">
                <strong>First registered:</strong> {formatDate(device.registered_at)}
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DeviceInfo;
